import { Form, FormInstance } from 'antd'
import { useEffect } from 'react'
import { useCustomQueryWithParams } from 'shared/hooks/useCustomQueryWithParams'
import { formKeys } from '../constants'
import { FormValues } from '@/pages/Donation/types'
import { GET_COUNTRY } from '@/shared/api/constants'
import { userInfoApi } from '@/shared/api'

export const useDefaultCountry = (form: FormInstance<FormValues>) => {
  const { data, error } = useCustomQueryWithParams(GET_COUNTRY, userInfoApi.getCounty)
  const country = data?.data
  const selectedCountry = Form.useWatch([formKeys.country], form)

  useEffect(() => {
    if (!selectedCountry && country && !error) {
      form.setFieldValue(formKeys.country, country)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country])
}
